module.exports = __webpack_public_path__ + "img/add_book.ef9bdd27.svg";